import backend from "../utils/backend";
import {
  GET_SEARCH_RESULTS,
  GET_SEARCH_RESULTS_SUCCESS,
  GET_SEARCH_RESULTS_UPDATE,
  GET_SEARCH_RESULTS_ERROR } from "../constants/actionTypes";

export const getSearchResults = (search, page=1, appendResults=false) => {
  return (dispatch) => {
    if (!appendResults) {
      dispatch({
        type: GET_SEARCH_RESULTS,
      });
    }

    return backend.request({
      method: "GET",
      url: "/search/",
      params: {
        search,
        page,
      },
    })
      .then((response) => {
        return dispatch({
          type: appendResults ? GET_SEARCH_RESULTS_UPDATE : GET_SEARCH_RESULTS_SUCCESS,
          payload: response.data.results,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_SEARCH_RESULTS_ERROR,
          payload: err,
        });
      });
  };
};
